export const DESC_TASK = "DESC_TASK";
export const GET_TASKDESC_REQUEST = "GET_TASKDESC_REQUEST";
export const GET_TASKDESC_SUCCESS = "GET_TASKDESC_SUCCESS";
export const TASKMAP_CHECKLIST_GET = "TASKMAP_CHECKLIST_GET";
export const NEW_CHECKLIST_TASKMAP_ADD = "NEW_CHECKLIST_TASKMAP_ADD";
export const TASKMAP_CHECKLIST_ORDER_CHANGED = "TASKMAP_CHECKLIST_ORDER_CHANGED";
export const TASKMAP_CHECKLIST_DELETE = "TASKMAP_CHECKLIST_DELETE";
export const TASKMAP_CHECKLIST_STATUS_CHANGED = "TASKMAP_CHECKLIST_STATUS_CHANGED";
export const RENAMED_TASK_SECCESS = "RENAMED_TASK_SECCESS";
export const CHANGED_TASK_VALUE = "CHANGED_TASK_VALUE";
export const CHANGED_TASK_COMPLETE_STATUS = "CHANGED_TASK_COMPLETE_STATUS";
export const CHANGE_TASK_DATES_SUSSECCFULLY = "CHANGE_TASK_DATES_SUSSECCFULLY";